window.Modals = new function()
{
    this.init = function() {
        jQuery('body').on('click', '.ajax-modal', function(event) {
            event.preventDefault();
            var href  = jQuery(this).attr('href');
            var modal = jQuery(this).data('bs-target');
            Modals.loadAjaxModal(href, modal);
        });

        jQuery('body').on('click', '.image-modal', function(event) {
            event.preventDefault();
            var href  = jQuery(this).attr('href');
            var modal = jQuery(this).data('bs-target');
            
            $(modal).find('.modal-body img').attr('src', href);
            $(modal).modal('show');
        });

        //Allow stacking of bootstrap modals if multiple are open at the same time
        let modalZIndex = 1050; // Bootstrap default z-index for modals

        $('body').on('shown.bs.modal', '.modal', function() {
            modalZIndex += 10; // Increment to ensure stacking
            $(this).css('z-index', modalZIndex);
            
            // Also ensure backdrop has a lower z-index
            $('.modal-backdrop').not('.modal-stack').css('z-index', modalZIndex - 5).addClass('modal-stack');
        });

        $('body').on('hidden.bs.modal', '.modal', function() {
            $(this).css('z-index', '');
            modalZIndex -= 10; // Reset z-index when modal is closed
        });
    };

    /**
     * Load dynamic content into a bootstrap modal
     *
     * @param string href - ajax route to load
     * @param string modal - id of modal to open
     */
    this.loadAjaxModal = function(href, modal) {
        $.ajax({
            url: href,
            type: 'GET',
            showloader: true,
            success: function(response) { 
                $(modal).find('.modal-body').html(response);

                if(response.includes('image-preview')) {
                    $(modal).modal({
                        backdrop: 'static'
                    });
                }

                $(modal).modal("show");
            }
        });
    };
}

jQuery(document).ready(function($) {
    Modals.init();
});
